import getNodeName from './getNodeName.js';

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

export { isTableElement as default };
